<div class="word-card" [class.word-card--compact]="compact">
  @if (showHeader) {
    <div class="word-card__header">
      <div class="word-card__icon" aria-hidden="true">W</div>
      <div>
        <p class="word-card__title">{{ 'tenders.responses.wizard.word-card-title' | translate }}</p>
        <p class="word-card__subtitle">{{ 'tenders.responses.wizard.word-card-subtitle' | translate }}</p>
      </div>
    </div>

    <hr class="word-card__divider" />
  }

  <div class="word-card__buttons">
    <a class="word-card__btn" [href]="wordDesktopUrl">
      <i class="ph ph-desktop word-card__btn-icon" aria-hidden="true"></i>
      <div class="word-card__btn-text">
        <span class="word-card__btn-label">{{
          (compact ? 'tenders.responses.wizard.word-card-btn-desktop-compact' : 'tenders.responses.wizard.word-card-btn-desktop')
            | translate
        }}</span>
        <span class="word-card__btn-sub">{{
          (compact ? 'tenders.responses.wizard.word-card-btn-desktop-sub-compact' : 'tenders.responses.wizard.word-card-btn-desktop-sub')
            | translate
        }}</span>
      </div>
    </a>
    <a class="word-card__btn" [href]="wordOnlineUrl" target="_blank" rel="noopener noreferrer">
      <i class="ph ph-globe word-card__btn-icon" aria-hidden="true"></i>
      <div class="word-card__btn-text">
        <span class="word-card__btn-label">{{
          (compact ? 'tenders.responses.wizard.word-card-btn-online-compact' : 'tenders.responses.wizard.word-card-btn-online') | translate
        }}</span>
        <span class="word-card__btn-sub">{{
          (compact ? 'tenders.responses.wizard.word-card-btn-online-sub-compact' : 'tenders.responses.wizard.word-card-btn-online-sub')
            | translate
        }}</span>
      </div>
    </a>
  </div>

  <div class="word-card__footer-links">
    <button type="button" class="word-card__manual" (click)="showManual = !showManual">
      <i class="ph ph-caret-right word-card__manual-chevron" [class.word-card__manual-chevron--open]="showManual"></i>
      {{ 'tenders.responses.wizard.word-card-manual' | translate }}
    </button>

    <span class="word-card__footer-sep" aria-hidden="true"></span>

    <a
      class="word-card__troubleshooting"
      href="https://s3-ao-writer.s3.eu-west-3.amazonaws.com/redaction-installation-troubleshooting.html"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="ph ph-wrench word-card__troubleshooting-icon" aria-hidden="true"></i>
      {{ 'tenders.responses.wizard.word-card-troubleshooting' | translate }}
      <i class="ph ph-arrow-square-out word-card__troubleshooting-arrow" aria-hidden="true"></i>
    </a>
  </div>

  @if (showManual) {
    <div class="word-card__manual-steps">
      @for (step of compact ? manualStepsCompact : manualSteps; track $index) {
        <div class="word-card__manual-step">
          <div class="word-card__manual-step-num">{{ $index + 1 }}</div>
          <span>{{ step | translate }}</span>
        </div>
      }
    </div>
  }
</div>
